import CreateDealer from "./CreateDealer";

export default CreateDealer;
